// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "NewbuildingPromoModalContainer" + "." + "65b20c94eaea582ee39f" + ".css";
};